<template>
  <div>
    <module-list :modules="modules" @updateSetup="doUpdate" @enabledChange='doChange'/>
  </div>
</template>

<script>
import ModuleList from "@/components/ModuleList.vue";
import menuCustomization from "@/mixins/menuCustomization.js";

export default {
  components: {
    ModuleList
  },
  mixins: [menuCustomization],
  data() {
    return {
      modules: [
        {
          id: "nav-sale-2",
          title: "商机",
          enabled: true,
          items: [
            {
              id: "quotation",
              logo: 'iconfont icon-wsbj green-font',
              title: "网上报价",
              path: "/sale/quote_list",
              enabled: true,
            },
            {
              id: "sampleReply",
              logo: 'iconfont icon-ypbj green-font',
              title: "样品报价",
              path: "/sale/sample_reply_list",
              enabled: true,
            }
          ]
        },
        {
          id: "nav-sale-1",
          title: "销售管理",
          enabled: true,
          items: [
            {
              id: "purchase",
              logo: 'iconfont icon-cgdd blue-font',
              title: "客户采购订单",
              path: "/b2b/purchase_list",
              enabled: true,
            },
            {
              id: "osMake",
              logo: 'iconfont icon-wxgd green-font',
              title: "客户外协订单",
              path: "/b2b/os_make_list",
              enabled: true,
            },
            {
              id: "deliveryreply",
              logo: 'iconfont icon-jqhf red-font',
              title: "交期回复",
              path: "/sale/delivery_reply_list",
              enabled: true,
            },
            {
              id: "sendNotice",
              logo: 'iconfont icon-wxth green-font',
              title: "发货提醒",
              path: "/sale/shipment_reminder_list",
              enabled: true,
            },
            {
              id: "saleBill",
              logo: 'iconfont icon-fp blue-font',
              title: "客户对账单",
              path: "/b2b/customer_bill_list",
              enabled: true,
            },
            {
              id: "billOutAR",
              logo: 'iconfont icon-cgdz green-font',
              title: "应收发票",
              path: "/b2b/bill_list",
              enabled: true,
            },
            {
              id: "AfterSale",
              logo: 'iconfont icon-khfp orange-font',
              title: "售后管理",
              path: "/crm/after_sale_list",
              enabled: true,
            }
          ]
        },
        {
          id: "",
          title: "基础资料",
          enabled: true,
          items: [
            {
              id: "customer-list-formpanel",
              logo: 'iconfont icon-kh green-font',
              title: "客户资料",
              path: "/document/customer_list",
              enabled: true,
            },
            {
              // id: "monry-report-paydetail",
              logo: 'iconfont icon-hetong orange-font',
              title: "电子印章",
              path: "/sys/seal_edit",
              enabled: true,
            }
          ]
        }
      ]
    };
  },
};
</script>

<style scoped>
</style>